import { Button, Form, message, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import { forgotPin } from "../../../../Services/AuthenticationServices/AuthenticationServices";
import {
  setAccessToken,
  setPhoneNumber,
  setRefreshToken,
  setSessionId,
  setVuaId,
} from "../../../../Services/LocalStorageServices";
import { Routes } from "../../../../Utils/Constants/routes";
import CommonModal from "../../../Common/Components/CommonModal";
import PinInput from "../../../Common/Components/PinInput";
import "./index.css";
import { useFingerprintValidation } from "../../FingerprintValidationContext";
interface IForgotPasswordProps {
  token: string;
}

const ForgotPassword: React.FC<IForgotPasswordProps> = ({ token }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [visible, setVisibility] = useState(true);
  const { replace } = useHistory();

  const forgotPasswordUpdate = (value: any) => {
    forgotPin(value.newPin, token).then(() => {
      form.resetFields();
      setVisibility(false);

      message.success(t("lblPinUpdateSuccess"));

      setAccessToken("");
      setSessionId("");
      setRefreshToken("");
      setPhoneNumber("");
      setVuaId("");

      replace(Routes.login);
    });
  };

  const [updatedPin, setUpdatePin] = useState({
    newPin: "",
    confirmNewPin: "",
  });

  const checkConfirmPassword = (_: any, value: string) => {
    if (value && value !== updatedPin.newPin && value.length === 6)
      return Promise.reject(new Error(t(translation.lblPinMatchError)));
    return Promise.resolve();
  };

  const onCancel = () => {
    setVisibility(false);
  };

  // const {checkFingerprint} = useFingerprintValidation();
  // useEffect(() => {
  //   // Check fingerprint
  //   checkFingerprint();
  // }, [checkFingerprint]);
  

  return (
    <CommonModal visible={visible} onCancel={onCancel}>
      <div className="col alignCenter ">
        <Typography.Text className="font24 fontWeight600 marginTop10">
          {t(translation.lblResetPin)}
        </Typography.Text>
        <Form
          form={form}
          className="width70 justifyCenter marginTop20"
          name="basic"
          onFinish={forgotPasswordUpdate}
          autoComplete="off"
          scrollToFirstError={true}
        >
          <Space direction="vertical" className="spacePIN">
            <div>
              <Typography.Text>{t("lblNewPin")}</Typography.Text>
              <PinInput
                label="New PIN"
                nameField="newPin"
                className="inputCss2 changePasscodePin"
                // tslint:disable-next-line: jsx-no-lambda
                onChange={(pin) =>
                  setUpdatePin((old) => ({ ...old, newPin: pin }))
                }
              />
            </div>
            <div>
              <Typography.Text>{t("lblConfirmPin")}</Typography.Text>

              <PinInput
                label="Confirm New PIN"
                nameField="confirmNewPin"
                className="inputCss2 changePasscodePin"
                customRule={checkConfirmPassword}
                // tslint:disable-next-line: jsx-no-lambda
                onChange={(pin) =>
                  setUpdatePin((old) => ({ ...old, confirmNewPin: pin }))
                }
              />
            </div>

            <div className="modalButtonGroup">
              <Button
                className="commonButtonBackground secondaryButton width40Pmargintop0"
                onClick={onCancel}
              >
                {t(translation.lblCancel)}
              </Button>

              <Button
                className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
                htmlType="submit"
              >
                {t(translation.lblResetPin)}
              </Button>
            </div>
          </Space>
        </Form>
      </div>
    </CommonModal>
  );
};
export default ForgotPassword;
